import { Link } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'

const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow bg-white">
        <div className="max-w-7xl mx-auto px-4 py-16 sm:py-24 lg:py-32">
          <div className="text-center">
            {/* 404 Illustration */}
            <div className="mb-8">
              <div className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-primary-50 mb-4">
                <svg className="h-16 w-16 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
            </div>

            {/* Error Message */}
            <h1 className="text-6xl font-extrabold text-gray-900 sm:text-8xl">
              404
            </h1>
            <h2 className="mt-4 text-3xl font-bold text-gray-800 sm:text-4xl">
              Page Not Found
            </h2>
            <p className="mt-4 max-w-md mx-auto text-base text-gray-500 sm:text-lg">
              Oops! The page you're looking for doesn't exist or has been moved.
            </p>

            {/* Action Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
              <Link
                to="/"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 transition-colors duration-200"
              >
                <svg className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                Return Home
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-5 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200"
              >
                Contact Support
              </Link>
            </div>

            {/* Helpful Links */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500 mb-4">You might want to try one of these pages:</p>
              <div className="flex flex-wrap justify-center gap-x-6 gap-y-3">
                <Link to="/services" className="text-sm text-primary hover:text-primary-700 transition-colors">
                  Our Services
                </Link>
                <span className="text-gray-300">|</span>
                <Link to="/portfolio" className="text-sm text-primary hover:text-primary-700 transition-colors">
                  Portfolio
                </Link>
                <span className="text-gray-300">|</span>
                <Link to="/about" className="text-sm text-primary hover:text-primary-700 transition-colors">
                  About Us
                </Link>
                <span className="text-gray-300">|</span>
                <Link to="/blog" className="text-sm text-primary hover:text-primary-700 transition-colors">
                  Blog
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default NotFound